//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum RowTypeGiftVatMode {
	DoNotApplyVatToDocument = 0,
	ApplyVatToDocumentTotalAndToPayTotal = 1,
	ApplyVatOnlyToDocumentTotal = 2,
	AskToSingleRow = 3
}
